// versi "react-qr-reader" 1.0.0. component API harus disesuaikan dengan yg baru

import { CameraswitchOutlined, QrCodeOutlined, QrCodeScanner, StopCircleOutlined } from "@mui/icons-material";
import { Button, Space } from "antd";
import Title from "antd/es/typography/Title";
import { useEffect, useState } from "react";
import { QrReader } from 'react-qr-reader';

// const QRScanner = () => {
// //   const [selected, setSelected] = useState("environment");
//   const [isFrontCam, setIsFrontCam] = useState(false); // back camera (environment) by default 
//   const [startScan, setStartScan] = useState(false);
//   const [loadingScan, setLoadingScan] = useState(false);
//   const [data, setData] = useState("");

//   const handleScan = async (scanData) => {
//     setLoadingScan(true);
//     console.log(`loaded data data`, scanData);
//     if (scanData && scanData !== "") {
//       console.log(`loaded >>>`, scanData);
//       setData(scanData);
//       setStartScan(false);
//       setLoadingScan(false);
//       // setPrecScan(scanData);
//     }
//   };
//   const handleError = (err) => {
//     console.error(err);
//   };
//   return (
//     <div>
//       <Button
//         size='large'
//         icon={startScan ? <StopCircleOutlined/> : <QrCodeOutlined/>}
//         onClick={() => {
//           setStartScan(!startScan);
//         }}
//       >
//         {startScan ? "Stop" : "Scan QR code"}
//       </Button>
//       {loadingScan && <p>Loading...</p>}
//       {data !== "" && <p>{data}</p>}
//       {startScan && (
//         <>
//             <Button size="large" icon={<CameraswitchOutlined/>} className="ml-2" onClick={()=>setIsFrontCam(!isFrontCam)}>{isFrontCam ? "Back" : "Front"}</Button>
//             <QrReader
//                 facingMode={isFrontCam ? "user" : "environment"}
//                 onError={handleError}
//                 onScan={handleScan}
//                 style={{ width: "300px" }}
//                 onResult={(result, error) => {
//                     if (!!result) {
//                       setData(result?.text);
//                     }
          
//                     if (!!error) {
//                       console.info(error);
//                     }
//                 }}
//             />
//         </>
//       )}
      
//     </div>
//   );
// };

const QRScanner = ({data, setData}) => {
    // const [data, setData] = useState('Scan failed. No data found.');
    const [isFrontCam, setIsFrontCam] = useState(false); // back camera (environment) by default 

    return (
        <div className="mt-5">
            {/* <Button
                size='large'
                icon={startScan ? <StopCircleOutlined/> : <QrCodeOutlined/>}
                onClick={() => {
                setStartScan(!startScan);
                }}
            >
                {startScan ? "Stop" : "Scan QR code"}
            </Button> */}
            {/* <Title level={5}>Scan QR Code:</Title> */}
            <Button icon={<CameraswitchOutlined/>} onClick={()=>setIsFrontCam(!isFrontCam)}>{isFrontCam ? "Back" : "Front"}</Button>
            <QrReader
                constraints={{facingMode: isFrontCam? "user" : "environment"}}
                onResult={(result, error) => {
                if (!!result) {
                    setData(result?.text);
                }

                if (!!error) {
                    console.info(error);
                }
                }}
                style={{ width: '100%', padding: 0, margin: 0}}
                containerStyle={{ width: '100%', padding: 0, margin: 0}}
            />
            {/* <p>{data}</p> */}
        </div>
    );
}

export default QRScanner;
